var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPatientLocked = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.045,
    height: 39.236,
    viewBox: "0 0 49.045 39.236",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-lock-solid-2",
    "data-name": "user-lock-solid",
    d: "M17.166,19.618A9.809,9.809,0,1,0,7.357,9.809,9.809,9.809,0,0,0,17.166,19.618Zm7.357,4.9a4.834,4.834,0,0,1,.621-2.337,10.487,10.487,0,0,0-1.111-.115h-1.28a13.34,13.34,0,0,1-11.173,0H10.3A10.3,10.3,0,0,0,0,32.367v3.19a3.678,3.678,0,0,0,3.678,3.678H25.2a4.869,4.869,0,0,1-.682-2.452Zm22.07-2.452H44.14V15.939a6.131,6.131,0,0,0-12.261,0V22.07H29.427a2.452,2.452,0,0,0-2.452,2.452V36.783a2.452,2.452,0,0,0,2.452,2.452H46.592a2.452,2.452,0,0,0,2.452-2.452V24.522A2.452,2.452,0,0,0,46.592,22.07ZM38.01,33.105a2.452,2.452,0,1,1,2.452-2.452A2.452,2.452,0,0,1,38.01,33.105ZM40.462,22.07h-4.9V15.939a2.452,2.452,0,0,1,4.9,0Z",
    fill: "#008c98"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPatientLocked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/patient-locked.c067ce64.svg";
export { ForwardRef as ReactComponent };